export default __webpack_public_path__ + "static/media/risk-result-2.de79bc01.svg";